<template>
  <div class="splash-container p-4">
    <div class="row mb-2">
      <div class="col">
        <input v-model="loginForm.email" @keyup.enter="login(loginForm)" type="text" class="form-control" placeholder="E-mail" required autofocus>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col">
        <input v-model="loginForm.password" @keyup.enter="login(loginForm)" type="password" class="form-control" placeholder="Password" required>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col text-center">
        <button class="btn btn-md btn-success center" type="button" @click="login(loginForm)"><i class="fa fa-sign-in"></i>Login</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      loginForm: {
        email: '',
        password: ''
      }
    }
  },

  methods: {
    ...mapActions({
      login: 'auth/login'
    })
  },

  created () {
    // If jwt token is present, redirect to landing page
    const persistedStore = JSON.parse(localStorage.getItem('vuex'))
    if (persistedStore && persistedStore.auth && persistedStore.auth.token) {
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/login.vue